import React from 'react';
import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonCollapseItem from '../../../common-components/common-collapse-item';
import CommonSmallText from '../../../common-components/common-small-text';

const list1 = [
    {
        title: 'Решение проблем, настройка и перенос сервера',
        subtitle: `<div class="gge-process-spoiler__text">Сначала решили проблему с&nbsp;нарушением работоспособности сервера. Изначально в&nbsp;некоторых обращениях прикрепленные файлы не&nbsp;отображались в&nbsp;административной зоне и&nbsp;не&nbsp;были доступны для скачивания. Потом настроили мониторинг серверов с&nbsp;помощью инструментов: Netdata, Prometheus, Grafana. Затем организовали переезд сайта на&nbsp;новый сервер, так как на&nbsp;старом были проблемы сети и&nbsp;жесткого диска с&nbsp;БД в&nbsp;режиме работы master &lt;&mdash;&gt; slave и&nbsp;в&nbsp;месте хостинга.</div> 
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src='/images/pic/gge/spoiler1-1.png' alt="" loading='lazy'></div>
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler1-2.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="gge-process-spoiler__small-text">Проблема с&nbsp;работоспособностью сервера. Было/стало</div>`,
    },
    {
        title: 'Настройка мониторинга сайта',
        subtitle: `<div class="gge-process-spoiler__text">Системный администратор настроил мониторинг сайта:</div>
                    <ul class="common__ol-list gge-process-spoiler__ol">
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>a.</span>
                            <span class="common__ol-info">Перевел lsyncd в&nbsp;demon режим на&nbsp;2&nbsp;серверах</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>b.</span>
                            <span class="common__ol-info">Настроил monit на&nbsp;для проверки (lsyncd, nginx, apache, mysql, ssh, cron, mount, агент мониторинга&nbsp;za, postfix);</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>c.</span>
                            <span class="common__ol-info">Скрыл версии nginx, php;</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>d.</span>
                            <span class="common__ol-info">Настроил сбор метрик состояния репликации;</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>e.</span>
                            <span class="common__ol-info">Настроил мониторинг дисковой подсистемы, настроил мониторинг доступности проекта извне по&nbsp;https протоколу;</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>f.</span>
                            <span class="common__ol-info">Сделал прямые apache-status и&nbsp;nginx-status и&nbsp;закрыл авторизацией для удобства отладки и&nbsp;дебага;</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>g.</span>
                            <span class="common__ol-info">Настроил уведомления на&nbsp;почту администратора.</span>
                        </li>
                    </ul>
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler2-1.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="gge-process-spoiler__small-text">Nginx-данные</div>`,
    },
    {
        title: 'Доработка калькулятора для расчета оплаты за услуги',
        subtitle: `<div class="gge-process-spoiler__text">В&nbsp;&laquo;Калькуляторе&raquo; пользователь может выбрать следующие услуги для расчета:</div>
                    <ul class="common__ol-list gge-process-spoiler__ol">
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>1.</span>
                            <span class="common__ol-info">Государственная экспертиза: результатов инженерных изысканий, проектной документации в&nbsp;части проверки достоверности определения сметной стоимости;</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>2.</span>
                            <span class="common__ol-info">Экспертное сопровождение.</span>
                        </li>
                     </ul>
                     <br />
                     <div class="gge-process-spoiler__text">Как переработали калькулятор?</div>
                     <ul>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>a.</span>
                            <span class="common__ol-info">Переписали на&nbsp;новый стек. Нам достался legacy code, с&nbsp;которым было сложно работать и&nbsp;мы&nbsp;выбрали React;</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>b.</span>
                            <span class="common__ol-info">Переработали логику формул. Некоторые формулы клиент попросил обновить для большего удобства при подсчетах;</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>c.</span>
                            <span class="common__ol-info">Убрали ошибки при формировании и&nbsp;сохранении pdf-файла с&nbsp;расчетами.</span>
                        </li>
                    </ul>
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler3-1.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="gge-process-spoiler__small-text">Страница с калькулятором</div>`,
    },
    {
        title: 'Запуск на&nbsp;трафикообразующие ключи',
        subtitle: `<div class="gge-process-spoiler__text">Доработка сервиса «Интернет-приемная»</div>
                    <ul class="common__ol-list gge-process-spoiler__ol">
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>a.</span>
                            <span class="common__ol-info">На&nbsp;обновленной форме обращения реализовали счетчик. Нужно было сделать так, чтобы счетчик не&nbsp;был визуально представлен в&nbsp;интернет-приемной. Но&nbsp;оповещения на&nbsp;почту поступали&nbsp;бы пронумерованные. Номер обращения формируется из&nbsp;года + шестизначный номер обращения. Пример: 2019000001, 2020000043, 2021003131. Этот номер будет уходить пользователю и&nbsp;сотруднику в&nbsp;шаблоне письма, а&nbsp;также отображаться в&nbsp;админ-панели. Плюсы в&nbsp;том, что не&nbsp;будет повторений и&nbsp;визуально в&nbsp;административной части можно сразу понять насколько старое обращение. А&nbsp;еще нумерация нужна для внутреннего учета обращений, так как помогает фиксировать время ответа на&nbsp;обращения.</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>b.</span>
                            <span class="common__ol-info">Вместе с&nbsp;номером обращения на&nbsp;почту пользователя теперь приходят и&nbsp;основные данные заявителя: дата обращения, ФИО, тип заявителя, текст обращения, способ получения ответа, контактные данные.</span>
                        </li>
                    </ul>
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler4-1.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="gge-process-spoiler__small-text">Админ-панель интернет-приемной</div>`,
    },
    {
        title: 'Реализация функции отписки от рассылки',
        subtitle: `<div class="gge-process-spoiler__text">При подписке на&nbsp;рассылку пользователь получал разовое уведомление, где можно было осуществить отписку. В&nbsp;последующих шаблонах возможности отписаться не&nbsp;было. Такое письмо может легко затеряться в&nbsp;почте, его можно случайно удалить и&nbsp;потерять возможность отписки навсегда. Поэтому мы&nbsp;внедрили во&nbsp;все шаблоны рассылки возможность отписки. Теперь пользователь может отказаться от&nbsp;получения новостей в&nbsp;любой момент.</div> 
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler5-1.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="gge-process-spoiler__small-text">Отписка от&nbsp;рассылки</div>`,
    },
    {
        title: 'Внедрение во все формы капчи',
        subtitle: `<div class="gge-process-spoiler__text">На&nbsp;сайте есть множество различных форм, по&nbsp;которым можно отправить заявку. Например, подписаться на&nbsp;рассылку, обратиться в&nbsp;интернет-приемную или оставить отзыв. С&nbsp;этих форм клиенту приходил спам на&nbsp;различных языках. Чтобы исправить эту проблему, мы&nbsp;поставили Captcha во&nbsp;все доступные на&nbsp;сайте формы.</div> 
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler6-1.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="gge-process-spoiler__small-text">Форма с&nbsp;ReCAPTCHA</div>`,
    },
    {
        title: 'Разработка функционала скрытия и показа блока «Подписаться на обновления»',
        subtitle: `<div class="gge-process-spoiler__text">На&nbsp;сайте в&nbsp;описании услуг и&nbsp;для семинаров в&nbsp;карточках элементов есть блок &laquo;Подписаться на&nbsp;обновления&raquo;, но&nbsp;он&nbsp;не&nbsp;всегда уместен. Так как на&nbsp;сайте будут со&nbsp;временем добавляться новые страницы, то&nbsp;нам нужно реализовать возможность скрывать и&nbsp;отображать на&nbsp;страницах услуг и&nbsp;семинаров кнопку Подписаться на&nbsp;обновления&quot;.</div> 
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler7-1.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="gge-process-spoiler__small-text">Подписка на&nbsp;обновления</div>`,
    },
    {
        title: 'Создание функционала по шерингу ссылок «Поделиться статьей»',
        subtitle: `<div class="gge-process-spoiler__text">Мы&nbsp;расширили функционал &laquo;Поделиться статьей&raquo; и&nbsp;добавили возможность переслать ссылку на&nbsp;материал по&nbsp;почте себе, чтобы не&nbsp;потерять, или другу. Для этого под статьей в&nbsp;специальную форму нужно просто ввести e-mail адресата и&nbsp;нажать кнопку &laquo;Отправить&raquo;.</div> 
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler8-1.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="gge-process-spoiler__small-text">Форма «Поделиться статьей»</div>`,
    },
    {
        title: 'Создание фильтрации в разделах с новостями',
        subtitle: `<ul class="common__ol-list gge-process-spoiler__ol">
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>a.</span>
                            <span class="common__ol-info">В&nbsp;разделе &laquo;Медиагалерея&raquo; добавили фильтрацию материалов по&nbsp;событиям. Например: День открытых дверей, Конференция, Круглый стол, Российский инвестиционно-строительный форум.</span>
                        </li>
                    </ul> 
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler9-1.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="gge-process-spoiler__small-text">Форма «Поделиться статьей»</div>
                    <ul class="common__ol-list gge-process-spoiler__ol">
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>b.</span>
                            <span class="common__ol-info">В&nbsp;разделе &laquo;Экспертное мнение&raquo; реализовали поиск материалов по&nbsp;ФИО эксперта.</span>
                        </li>
                    </ul>
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler9-2.png" alt="" loading='lazy'></div>
                    </div> 
                    <div class="gge-process-spoiler__small-text">Фильтрация по&nbsp;ФИО эксперта</div>
                    <ul class="common__ol-list gge-process-spoiler__ol">
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>c.</span>
                            <span class="common__ol-info">В&nbsp;разделе &laquo;Вопрос-ответ&raquo; ввели дополнительную фильтрацию по&nbsp;теме вопроса, так как некоторые вопросы, которые относятся к&nbsp;одной из&nbsp;услуг, подразделяются на&nbsp;темы.</span>
                        </li>
                    </ul>
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler9-3.png" alt="" loading='lazy'></div>
                    </div> 
                    <div class="gge-process-spoiler__small-text">Фильтрация по&nbsp;теме вопроса</div>`,
    },
]; // Автоматизировать отрисовку, такое только на первое время, спросить.

const list2 = [
    {
        title: 'Установка сервисов по&nbsp;вылавливанию ошибок',
        subtitle:
            'Для того, чтобы отлавливать и&nbsp;анализировать ошибки, которые могут быть на&nbsp;проекте на&nbsp;стороне фронта и&nbsp;backend, установили сервис мониторинга Sentry. Теперь все ошибки можно отследить в&nbsp;частном телеграм-канале проекта, в&nbsp;котором состоят только наши разработчики.',
    },
    {
        title: 'Оперативное решение проблем',
        subtitle: ` <ul class="common__ol-list gge-process-spoiler__ol">
                        <li  class="common__ol-item ol-item-title">
                            <span class="common__ol-number" style='color: #9d2235'>a.</span>
                            <span class="common__ol-info">
                                <span class="common__ol-info-title">Сборка стилей</span>
                                 Они перестали собираться обычной командой, нужно только что-то поменять в&nbsp;существующих файлах, чтобы произошла пересборка, тогда становится все нормально. Мы&nbsp;заменили [deprecated] extract-text-webpack-plugin на&nbsp;новый MiniCssExtractPlugin, для сборки стилевых файлов. Из-за этого пропал баг со&nbsp;сборкой. Также поменяли принцип сборки less и&nbsp;css стилей, так как раньше работало некорректно, в&nbsp;стили добавлялись лишние json-модули.</span>
                        </li>
                        <li  class="common__ol-item ol-item-title">
                            <span class="common__ol-number" style='color: #9d2235'>b.</span>
                            <span class="common__ol-info">
                                <span class="common__ol-info-title">Подписка на рассылки</span>
                                 Реализовали отображение чекбоксов для подписки на&nbsp;множественные и&nbsp;одиночные рассылки. При проверке обнаружилось, что при попытке подписки функционал не&nbsp;отрабатывает и&nbsp;пользователь не&nbsp;отображается в&nbsp;списке подписчиков в&nbsp;системе управления. Мы&nbsp;изучили проблему и&nbsp;выяснили, что ошибка проявлялась для подписчиков, созданных вручную через админ панель. Они не&nbsp;проходили проверку функцией CSubscription::IsAuthorized($ID). Для решения проблемы добавили принудительную авторизацию существующих подписок.</span>
                        </li>
                        <li  class="common__ol-item ol-item-title">
                            <span class="common__ol-number" style='color: #9d2235'>c.</span>
                            <span class="common__ol-info">
                                <span class="common__ol-info-title">Проблемы с версткой</span>
                           Например, пропали некоторые иконки, присутствовали видоизмененные шрифты. А&nbsp;на&nbsp;странице с&nbsp;новостями нужно было выровнять блоки, исправить работоспособность кнопки, закрывающей форму.</span>
                        </li>
                        <li  class="common__ol-item ol-item-title">
                            <span class="common__ol-number" style='color: #9d2235'>d.</span>
                            <span class="common__ol-info">
                                <span class="common__ol-info-title">Некорректная сортировка для услуги &laquo;Экспертное сопровождение&raquo;.</span>
                           Создали новую услугу, в&nbsp;меню она должна подменить другую, но&nbsp;в&nbsp;итоге сдвигается по&nbsp;приоритету ниже другим блоком. В&nbsp;следствии отладки, выяснилось, что первый уровень сортировки работал по&nbsp;id&nbsp;услуги. Мы&nbsp;это исправили, чтобы первый уровень был по&nbsp;полю &laquo;Сортировка&raquo;, а&nbsp;второй уже по&nbsp;id.</span>
                        </li>
                    </ul>`,
    },
    {
        title: 'Создание полей и&nbsp;форм',
        subtitle: `<ul class="common__ol-list gge-process-spoiler__ol">
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>a.</span>
                            <span class="common__ol-info">Государственная экспертиза: результатов инженерных изысканий, проектной документации в&nbsp;части проверки достоверности определения сметной стоимости;</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>b.</span>
                            <span class="common__ol-info">Экспертное сопровождение.</span>
                        </li>
                    </ul>`,
    },
    {
        title: 'Технический аудит реализации задач',
        subtitle: `<ul class="common__ol-list gge-process-spoiler__ol">
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #9d2235'>a.</span>
                            <span class="common__ol-info">Создали по&nbsp;просьбе клиента страницу &laquo;Рассмотренные проекты&raquo;, которая является аналогом страницы &laquo;Национальные проекты&raquo;, но&nbsp;со&nbsp;своей структурой. Разделы выглядят идентично, с&nbsp;разницей в&nbsp;фильтрации новостных блоков. На&nbsp;странице &laquo;Национальные проекты&raquo; присутствует фильтрация по&nbsp;годам, когда в&nbsp;рассмотренных&nbsp;&mdash; еще и&nbsp;по&nbsp;отраслям;</span>
                        </li>
                        <li  class="common__ol-item ol-item-title">
                            <span class="common__ol-number" style='color: #9d2235'>b.</span>
                            <span class="common__ol-info">
                                <span class="common__ol-info-title">Реализация блока &laquo;FAQ&raquo; на&nbsp;главной странице.</span>
                                 Нужно было собрать блок &laquo;Вопрос-ответ&raquo; после раздела с&nbsp;контактами. Он&nbsp;должен быть в&nbsp;виде плитки наподобие блока &laquo;Учебный центр&raquo; или &laquo;Пресс-центр&raquo;. Так как у&nbsp;нас уже был дизайн этих блоков, мы&nbsp;просто пересобрали текст и&nbsp;картинки.</span>
                        </li>
                    </ul>`,
    },
    {
        title: 'Создание шаблона письма для рассылки',
        subtitle: `<div class="gge-process-spoiler__text">Сделали дизайн и&nbsp;сверстали шаблоны для новостных рассылок.</div> 
                    <div class="gge-process-spoiler__img-container">
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler2-5-1.png" alt="" loading='lazy'></div>
                        <div class="gge-process-spoiler__img"><img src="/images/pic/gge/spoiler2-5-2.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="gge-process-spoiler__small-text">Форма &laquo;Поделиться статьей&raquo;</div>`,
    },
];

const Process = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper caseName="gge-process" bigPaddings={true} isMargin={false}>
                <div className="gge-process__wrapper">
                    <div className="gge-process__container">
                        <div className="gge-process__img-container">
                            <CommonTitle>Процесс</CommonTitle>
                            <CommonUsualText className="gge-process__subtitle">
                                Сначала мы&nbsp;провели точечные работы по&nbsp;модернизации сайта,
                                чтобы упростить функционал и&nbsp;сделать его более удобным для
                                пользователя, затем взяли сайт на&nbsp;техподдержку.
                            </CommonUsualText>
                        </div>
                        <div className="gge-process__info">
                            <CommonSmallTitle>
                                В&nbsp;работы по&nbsp;модернизации сайта вошло:
                            </CommonSmallTitle>
                            <div className="gge-process__list">
                                {list1.map(({ title, subtitle }, index) => (
                                    <CommonCollapseItem
                                        key={index}
                                        white={true}
                                        index={++index}
                                        triggerText={parse(title)}
                                        content={parse(subtitle)}
                                        numberColor={'#9d2235'}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: subtitle }} />
                                    </CommonCollapseItem>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="gge-process__container">
                        <div className="gge-process__img-container"></div>
                        <div className="gge-process__info">
                            <CommonSmallTitle>Работы по&nbsp;поддержке сайта</CommonSmallTitle>
                            <CommonSmallText>
                                В&nbsp;список этих работ входят небольшие оперативные решения.
                                Например, разместить баннер или документ, заменить какую-то
                                информацию или добавить форму. На&nbsp;каждую поддержку проекта
                                мы&nbsp;выделяем менеджера и&nbsp;команду быстрого реагирования. Для
                                Главгосэкспертизы мы&nbsp;сделали много различных работ:
                            </CommonSmallText>
                            <div className="gge-process__list">
                                {list2.map(({ title, subtitle }, index) => (
                                    <CommonCollapseItem
                                        key={index}
                                        white={true}
                                        index={++index}
                                        triggerText={parse(title)}
                                        content={parse(subtitle)}
                                        numberColor={'#9d2235'}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
